/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import PropTypes from 'prop-types';
import { getContentByLocal } from '../../../../utils';
import CardList from '../CardList';

const UploadList = (props) => {
    const { uploadList, i18n, selectedLanguage, handelUploadList, addBtnStatus } = props;

    return (
        <div role="menu">
            {
                uploadList && uploadList.map((question, index) => {
                    const { questionLocales, questionStatus, questionId, questionIndicator } = question;
                    const questionStatusNumber = parseInt(questionStatus, 10);
                    const contentTmp = {
                        title: {
                            dataKey: `title-${questionIndicator}`,
                            text: getContentByLocal(questionLocales, selectedLanguage)
                        },
                        statusTitle: {
                            dataKey: `statusTitle-${questionIndicator}`,
                            text: questionStatusNumber === 2 ? i18n.uploadStatus.complete : i18n.uploadStatus.incomplete,
                            failText: i18n.uploadStatus.fail,
                            checkText: i18n.status.incomplete
                        },
                        isComplete: questionStatusNumber === 2 ? true : false,
                        isIncomplete: questionStatusNumber === 1 ? true : false,
                        isFail: questionStatusNumber === 3 ? true : false,
                        isChecked: questionStatusNumber === 4 ? true : false
                    }
                    if(questionIndicator === "MenuOtherDocFile" || questionIndicator === "MenuOtherDocFileOff") {
                        return ( !addBtnStatus &&
                            <CardList
                                content={contentTmp}
                                key={index}
                                questionId={questionId}
                                questionIndicator={questionIndicator}
                                index={index}
                                handelCardItem={handelUploadList}
                            />
                        )
                    } else {
                        return (
                            <CardList
                                content={contentTmp}
                                key={index}
                                questionId={questionId}
                                questionIndicator={questionIndicator}
                                index={index}
                                handelCardItem={handelUploadList}
                            />
                        )
                    }
                    
                })
            }
        </div>
    )
};



UploadList.propTypes = {
    uploadList: PropTypes.array.isRequired,
    i18n: PropTypes.object,
    selectedLanguage: PropTypes.string,
    handelUploadList: PropTypes.func,
    addBtnStatus:PropTypes.bool,

};


export default UploadList;



// WEBPACK FOOTER //
// ./src/views/AOFormReview/components/UploadList/index.js